// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1E6RT","info":"PatientInfo_info__xERTT"};